import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ChangeDetectionStrategy
} from "@angular/core";
import { UserRightsService } from "../../../services/user-rights.service";
import { StateDisplayerType } from "../state-displayer/state-displayer.component";
import { MatCheckbox } from "@angular/material/checkbox";
import { TranslateModule } from "@ngx-translate/core";

@Component({
  selector: "app-state-displayer-column-names",
  templateUrl: "./state-displayer-column-names.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ["./state-displayer-column-names.component.scss"],
  imports: [MatCheckbox, TranslateModule]
})
export class StateDisplayerColumnNamesComponent implements OnInit {
  @Output() checkboxUpdate?: EventEmitter<void> = new EventEmitter();

  @Input() type: StateDisplayerType;
  @Input() hasCheckbox: boolean;

  constructor(private _userRightsService: UserRightsService) {}

  ngOnInit(): void {}

  protected isAdmin(event: string): boolean {
    return this._userRightsService.getUserRightLevel(event);
  }
}
